import { TPublicationConfig } from '@vNext/models/PublicationConfig/PublicationConfig';
import { generalConfig } from './general';
import { homePageConfig } from './homePage';
import { subscriptionPageConfig } from './subscriptionPage';

const publicationConfig: TPublicationConfig = {
    generalConfig,
    homePageConfig,
    subscriptionPageConfig,
};

export { publicationConfig };
